/**
 * BGM Info Display Component
 *
 * Displays the current BGM title and artist.
 */

import React from 'react';
import './BGMInfoDisplay.css';

interface BGMInfoDisplayProps {
    title?: string;
    artist?: string;
    visible?: boolean;
}

export const BGMInfoDisplay: React.FC<BGMInfoDisplayProps> = ({
    title = '',
    artist = '',
    visible = false
}) => {
    return (
        <div
            id="bgm-info-display"
            className={`bgm-info-display ${visible ? 'visible' : ''}`}
        >
            <div id="bgm-title-display" className="bgm-title">
                {title}
            </div>
            <div id="bgm-artist-display" className="bgm-artist">
                {artist}
            </div>
        </div>
    );
};

export default BGMInfoDisplay;
